export default __webpack_public_path__ + "static/media/try2.b39af31a.png";